import RepoApiRequest from "../../utils/bcc-repo-api-request";
import endpoints from "../repo-api-endpoints";

const verify = async (token) => {
  if (!token) return null;
  try {
    const result = await RepoApiRequest({
      url: endpoints.download.verifyByRecaptchaToken(token),
    });

    if (!result) throw new Error();
    return result;
    // if(!result.data || !result.data.length) throw new Error();
    // return result.data[0];
  } catch (err) {
    return {
      success: false,
      score: 0,
      action: "file_download",
      expires: 0,
      signatureHash: null,
    };
  }
};
const repository = { verify };

export { verify };
export default repository;
